module.exports = __webpack_public_path__ + "c82aeb7ab233935f5022b3541e226f96.pdf";